// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as Stack from "../../resources/layout-and-structure/Stack.res.js";
import * as React from "react";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as PriceCalculator from "../../core/PriceCalculator.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as InputOptionalNumberField from "../../resources/selection-and-input/InputOptionalNumberField.res.js";

function PriceRetailTableEditCell(props) {
  let onError = props.onError;
  let onChange = props.onChange;
  let __shrinkInput = props.shrinkInput;
  let __autoFocused = props.autoFocused;
  let purchasePrice = props.purchasePrice;
  let taxRate = props.taxRate;
  let taxIncluded = props.taxIncluded;
  let valueExcludingTax = props.valueExcludingTax;
  let autoFocused = __autoFocused !== undefined ? __autoFocused : false;
  let shrinkInput = __shrinkInput !== undefined ? __shrinkInput : false;
  let match = React.useState(() => false);
  let setErrored = match[1];
  let errored = match[0];
  React.useEffect(() => {
    setErrored(param => Stdlib_Option.mapOr(valueExcludingTax, false, value => value < purchasePrice));
  }, [valueExcludingTax]);
  React.useEffect(() => {
    if (errored && onError !== undefined) {
      onError();
    }
  }, [errored]);
  let value = taxIncluded ? props.valueIncludingTax : valueExcludingTax;
  let onChange$1 = React.useCallback(value => onChange(taxIncluded ? Stdlib_Option.map(value, __x => PriceCalculator.Retail.Tax.removeBack(__x, taxRate)) : value), [taxRate]);
  let tmp;
  if (taxIncluded) {
    let formattedValueExcludingTax = I18n.currencyFormat(undefined, "EUR", undefined, undefined, Stdlib_Option.getOr(valueExcludingTax, 0)) + " " + I18n.t("HT");
    tmp = JsxRuntime.jsx(TextStyle.make, {
      children: formattedValueExcludingTax,
      variation: "normal",
      size: "xxsmall"
    });
  } else {
    tmp = null;
  }
  return JsxRuntime.jsxs(Stack.make, {
    children: [
      JsxRuntime.jsx(InputOptionalNumberField.make, {
        value: value,
        minValue: 0,
        errorMessage: errored ? "" : undefined,
        placeholder: "0,00",
        appender: {
          TAG: "Custom",
          _0: I18n.toCurrencySymbol("EUR") + Stdlib_Option.mapOr(props.bulkUnit, "", unit => ` / ` + unit)
        },
        shrinkInput: shrinkInput,
        autoFocused: autoFocused,
        onChange: onChange$1,
        onFocus: props.onFocus,
        onBlur: props.onBlur
      }),
      tmp
    ],
    space: taxIncluded ? "xsmall" : "none"
  });
}

let make = React.memo(PriceRetailTableEditCell);

export {
  make,
}
/* make Not a pure module */
